import { Main } from './components';

export type PackagingRulesetsProps = {
  /** Equipo hijo cuando la ruta es `/clients/:id/packaging-rulesets` (3PL). */
  scopedTeamId?: number;
};

const PackagingRulesets = ({ scopedTeamId }: PackagingRulesetsProps) => <Main scopedTeamId={scopedTeamId} />;

export default PackagingRulesets;
